export default __webpack_public_path__ + "static/media/shelf-logo.1ccda0c7.png";